import { Help } from '@atlaskit/atlassian-navigation';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { HeadingItem, MenuGroup, Section } from '@atlaskit/menu';
import Popup, { ContentProps } from '@atlaskit/popup';
import { isFedRamp } from '@atlassian/atl-context';
import React, { useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { LINK_URLS } from '../../../../constants/links';
import TrackedLinkItem from '../../../common/TrackedLinkItem';

const HelpMenuContent: React.FC<ContentProps> = () => {
  return (
    <MenuGroup minWidth="300px">
      <Section>
        <HeadingItem>Help</HeadingItem>
        {!isFedRamp() && (
          <TrackedLinkItem
            description={<FormattedMessage {...messages.startTrialDescription} />}
            iconAfter={<ShortcutIcon label="" />}
            href={LINK_URLS.WAC}
            actionSubject="menuItem"
            action="clicked"
            extraAnalyticProps={{
              item: 'wac',
            }}
            openInNewTab
            synchroniseSession={true}
            synchronisationApplication="wac"
          >
            <FormattedMessage {...messages.startTrialLabel} />
          </TrackedLinkItem>
        )}
        <TrackedLinkItem
          description={<FormattedMessage {...messages.getSupportDescription} />}
          iconAfter={<ShortcutIcon label="" />}
          href={LINK_URLS.SUPPORT}
          actionSubject="menuItem"
          action="clicked"
          extraAnalyticProps={{
            item: 'support',
          }}
          openInNewTab
        >
          <FormattedMessage {...messages.getSupportLabel} />
        </TrackedLinkItem>
      </Section>
    </MenuGroup>
  );
};

const NavHelpButton: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <Popup
      placement="bottom-end"
      content={HelpMenuContent}
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      testId="nav__help-menu"
      trigger={triggerProps => (
        <Help
          isSelected={isOpen}
          testId="nav__help-menu-trigger"
          onClick={() => setOpen(!isOpen)}
          tooltip={<FormattedMessage {...messages.helpLabel} />}
          {...triggerProps}
        />
      )}
    />
  );
};

export default NavHelpButton;

const messages = defineMessages({
  feedback: {
    defaultMessage: 'Give Feedback',
    description: `Label for the support`,
    id: 'uchi.help.feedback',
  },
  getSupportDescription: {
    defaultMessage: 'Resources for users and administrators',
    description: `Generic label used for give feedback button`,
    id: 'uchi.help.get-support.description',
  },
  getSupportLabel: {
    defaultMessage: 'Get support',
    description: `Label for the support`,
    id: 'uchi.help.get-support.label',
  },
  helpLabel: {
    defaultMessage: 'Help',
    description: `Generic label used for the help section`,
    id: 'uchi.help.label',
  },
  startTrialDescription: {
    defaultMessage: 'Start a product trial',
    description: `Generic label used for give feedback button`,
    id: 'uchi.help.start-trial.description',
  },
  startTrialLabel: {
    defaultMessage: 'Atlassian.com',
    description: `Generic label used for give feedback button`,
    id: 'uchi.help.start-trial.label',
  },
});
